import { PaymentFieldType } from '@endeavour/payment-integration';
import { PaymentField, PaymentMethodType } from '../method.interface.js';

// Indicates the customer’s bank account type for the withdraw.
// C = Current Account and
// S = Savings Account
// It should be displayed for the customer on the merchant cashier as:
// C = Current Account > “Conta Corrente de Pessoa Física”
// S = Savings Account > “Conta Poupança de Pessoa Física”.
// Not required if paymentMethod is pix.
const bankFields = [
    {
        type: PaymentFieldType.TEXT,
        name: PaymentField.BRANCH,
        key: PaymentField.BRANCH,
    },
    {
        type: PaymentFieldType.TEXT,
        name: PaymentField.ACCOUNT,
        key: PaymentField.ACCOUNT,
    },
    {
        type: PaymentFieldType.SELECT,
        name: PaymentField.ACCOUNT_TYPE,
        key: PaymentField.ACCOUNT_TYPE,
        options: [
            {
                value: 'C',
                name: 'Conta Corrente de Pessoa Física',
            },
            {
                value: 'S',
                name: 'Conta Poupança de Pessoa Física',
            },
        ],
    },
];
function getForm(isDeposit, specificMethodType, prefilledData) {
    if (specificMethodType) {
        return specificMethodType === PaymentMethodType.PIX ? [] : bankFields;
    }
    return [
        {
            type: PaymentFieldType.SELECT,
            name: PaymentField.PAYMENT_METHOD,
            key: PaymentField.PAYMENT_METHOD,
            options: [
                {
                    value: PaymentMethodType.PIX,
                    name: 'PIX',
                },
                {
                    value: PaymentMethodType.BANCO_DO_BRASIL,
                    name: 'Banco do Brasil',
                },
                {
                    value: PaymentMethodType.BRADESCO,
                    name: 'Bradesco',
                },
                {
                    value: PaymentMethodType.CAIXA,
                    name: 'Caixa',
                },
                {
                    value: PaymentMethodType.NUBANK,
                    name: 'Nubank',
                },
                {
                    value: PaymentMethodType.SANTANDER,
                    name: 'Santander',
                },
            ],
        },
        {
            type: PaymentFieldType.TEXT,
            name: PaymentField.EMAIL,
            key: PaymentField.EMAIL,
            defaultValue: prefilledData?.email ? prefilledData.email : undefined,
        },
        ...(!isDeposit
            ? bankFields.map((field) => {
                return {
                    ...field,
                    isVisible: (formData) => {
                        return formData?.['paymentMethod'] !== PaymentMethodType.PIX;
                    },
                };
            })
            : []),
    ];
}

export { getForm };
